import React, { useEffect, useState } from 'react';
import Input from './Input';
import {
  getCurrencySymbol,
  getCurrencyDecimals,
  getDecimalSeparator,
  formatAmountForInput,
} from '../../utils/currency';

// Casas e separador vem da MOEDA, nao mais cravados no formato brasileiro:
// numa loja USD o campo mostrava "10,00" em vez de "10.00".
const DECIMAL_SIZE = getCurrencyDecimals();

const InputMoney = ({ value, onChange, addonBefore = getCurrencySymbol(), ...props }) => {
  const getFormattedValue = (val) => {
    if (val === null || val === undefined || val === '') return formatAmountForInput(0);
    return formatAmountForInput(typeof val === 'number' ? val : parseFloat(val) || 0);
  };

  const [currentValue, setCurrentValue] = useState(getFormattedValue(value));

  useEffect(() => {
    const valueString = value.toString();

    if (!/\D/.test(valueString.replace('.', ''))) {
      setCurrentValue(getFormattedValue(value));
    }
  }, [value]);

  const handleOnChange = (event) => {
    // Tira o separador que o proprio campo escreveu -- qualquer um dos dois, para
    // aguentar valor que sobrou de uma sessao em outra moeda.
    const valueRemoved = String(event.target.value).replace(/[.,]/g, '');

    // Sem casas decimais (LBP) o que foi digitado ja e o valor inteiro.
    const sizeSlice = valueRemoved.length - DECIMAL_SIZE;
    const newValue = DECIMAL_SIZE === 0
      ? valueRemoved
      : [valueRemoved.slice(0, sizeSlice), '.', valueRemoved.slice(sizeSlice)].join('');

        onChange({
        ...event,
        target: {
            ...event.target,
            value: newValue,
        },
        });
  };

  return (
    <Input addonBefore={addonBefore} value={currentValue} onChange={handleOnChange} {...props} />
  );
};

export default InputMoney;
